export default "__VITE_ASSET__BxPg36Fj__"